export default "__VITE_ASSET__CtdUzC7Q__"